export const loginPath = () => "/login";
export const forgotPasswordPath = () => "/forgot-password";
